
import i18next from "i18next"

import { catchError, getError, http } from "services/http"
import { ErrorFn, ErrorResponse, User } from "models"

const getTeam = async (entityId: string): Promise<{ res: User[] } & ErrorFn> => {
    const getTeamErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
            case "EntityNotFoundException":
                return { code: error?.code, message: i18next.t("edit_errorEntityNotFoundException", { ns: "api" }) }
            default:
                return { code: error?.code, message: i18next.t("get_infos_error", { ns: "api" }) }
        }
    }
    const res = await http
        .get<User[]>(`obikeapi/entity/users?entity_id=${entityId}`, {})
		.then((res) => res.data)
        .catch(e => catchError(e))

    return {
        res: res as User[],
        getError: getError(res as unknown as ErrorResponse, getTeamErrors)
    }
}

export type UserProfilProps = {
    description?: {
        nom: string,
        prenom: string
    },
    permission?: number,
    user_id?: string,
    row_version?: string
    entity_id?: string
    mail?: string
    registermailtemplate?: string
    status?: number
}

export type UserProfilResponse = {
    user_id: string,
    status: number,
    row_version: string,
    gender_id: string,
    permission: number
}

const postProfil = async (profil: UserProfilProps): Promise<{ res: UserProfilResponse } & ErrorFn> => {
    const postProfilErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "Access token is required.":
                        return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
                    default:
                        return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
                }
            case "EntityNotFoundException":
                return { code: error?.code, message: i18next.t("edit_errorEntityNotFoundException", { ns: "api" }) }
            case "UserNotFoundException":
                return { code: error?.code, message: i18next.t("edit_errorUserNotFoundException", { ns: "api" }) }
            case "MailNotAvailableException":
                return { code: error?.code, message: i18next.t("edit_MailNotAvailableException", { ns: "api" }) }
            case "TooManyRequestsException":
                return { code: error?.code, message: i18next.t("edit_error_TooManyRequestsException", { ns: "api" }) }
            case "InvalidArgument":
                switch (error?.message) {
                    case "Bad operateur value.":
                        return { code: error?.code, message: i18next.t("add_invalid_operator_error", { ns: "api" }) }
                    default:
                        return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
                }
            default:
                return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
        }
    }
    const res = await http
        .post<UserProfilResponse>("obikeapi/entity/user", profil, {})
		.then((res) => res.data)
        .catch(e => catchError(e))

    return {
        res: res as UserProfilResponse,
        getError: getError(res, postProfilErrors)
    }
}

const putProfil = async (profil: UserProfilProps): Promise<{ res: any } & ErrorFn> => {
    const putProfilErrors = (error: ErrorResponse) => {
        switch (error?.code) {
            case "NotAuthorizedException":
                switch (error?.message) {
                    case "Access token is required.":
                        return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
                    default:
                        return { code: error?.code, message: i18next.t("edit_error_NotAuthorizedException", { ns: "api" }) }
                }
            case "EntityNotFoundException":
                return { code: error?.code, message: i18next.t("edit_errorEntityNotFoundException", { ns: "api" }) }
            case "UserNotFoundException":
                return { code: error?.code, message: i18next.t("edit_errorUserNotFoundException", { ns: "api" }) }
            case "MailNotAvailableException":
                return { code: error?.code, message: i18next.t("edit_MailNotAvailableException", { ns: "api" }) }
            case "TooManyRequestsException":
                return { code: error?.code, message: i18next.t("edit_error_TooManyRequestsException", { ns: "api" }) }
            default:
                return { code: error?.code, message: i18next.t("add_global_error", { ns: "api" }) }
        }
    }
    const res = await http
        .put("obikeapi/entity/user", profil, {})
		.then((res) => res.data)
        .catch(e => catchError(e))

    return {
        res,
        getError: getError(res, putProfilErrors)
    }
}

export { getTeam, postProfil, putProfil }
